import { Select as AntSelect } from 'antd';
import { ReactNode } from 'react';
import styled, { DefaultTheme, StyledComponent } from 'styled-components';
import { Input, InputNumber } from 'components/atoms/input';
import { InputDuration } from 'components/atoms/input-duration';
import {
  BackgroundColor,
  Height,
  InputBorder,
  InputFocus,
} from 'components/atoms/input/input';
import { OutlineError } from 'components/styles';
import { StyledSelect } from '../field-value/styled-select';

export const Select = styled(AntSelect).attrs<{
  width?: number;
  suffixIcon?: ReactNode;
}>(({ width, suffixIcon }) => ({
  bordered: false,
  placeholder: 'Select...',
  style: { minWidth: width ?? 160 },
  autoFocus: true,
  suffixIcon,
  dropdownMenuStyle: {
    width: '240px',
  },
}))`
  padding-left: var(--layout-01);
` as StyledComponent<typeof AntSelect, DefaultTheme, { width?: number }, never>;

export const Text = styled.div`
  min-width: 80px;
  text-align: right;
`;

/** TODO: Move out to custom select component */
export const Fields = styled(Select)`
  background: var(--coolest-gray-20);
  padding-left: var(--spacing-03);
  ${BackgroundColor};
  ${InputBorder};
  ${Height};
  padding-left: 0;
  &.ant-select-open,
  &:focus-within {
    ${InputFocus};
  }
  .ant-select-selector {
    ${Height};
    display: flex;
    align-items: center;
    padding: 0 var(--spacing-05);
  }
  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    right: var(--spacing-05);
    left: var(--spacing-05);
    .ant-select-selection-search-input {
      ${Height};
      padding-right: var(--spacing-05);
    }
  }
`;

export const NumericInput = styled(InputNumber).attrs({
  placeholder: 'Enter value',
  autoFocus: true,
})`
  background: var(--coolest-gray-10);
  min-width: 280px;
`;

export const DurationInput = styled(InputDuration)`
  &.has-error {
    ${OutlineError};
    &:focus {
      box-shadow: none;
      ${OutlineError};
    }
  }
`;

export const FilterSelect = styled(StyledSelect)`
  min-width: 320px;
`;

export const TextInput = styled(Input).attrs({
  type: 'text',
  placeholder: 'Enter value',
  autoFocus: true,
})`
  background: var(--coolest-gray-10);
  min-width: 280px;
`;
